import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Documents = createSvgIcon(React.createElement("path", { fill: "#2C2C2A", d: "M21,24H3c-0.552,0-1-0.447-1-1V1c0-0.552,0.448-1,1-1h18c0.553,0,1,0.448,1,1v22\n\tC22,23.553,21.553,24,21,24z M4,22h16V2H4V22z" }), 'Documents');
export default Documents;
